import { combineReducers } from 'redux';
import ordersReducer from './orders/ordersReducer';
import productsReducer from './products/productsReducer';
import reportsReducer from './reports/reportReducer';
import profileReducer from './overview/profile/profileReducer';
import alertReducer from './alerts/alertsReducer';
import settingsReducer from './settings/settingsReducer';
import overviewReducer from './overview/overviewReducer';
import withdrawReducer from './withdraw/Reducer';
import preferenceReducer from './preferences/Reducer';

// Combining all the reducers to be available through useSelector Hook
const rootReducer = combineReducers({
    products: productsReducer,
    orders: ordersReducer,
    withdraw: withdrawReducer,
    reports: reportsReducer,
    profile: profileReducer,
    preferences: preferenceReducer,
    alert: alertReducer,
    settings: settingsReducer,
    orderSummary: overviewReducer.orderSummaryReducer,
    productSummary: overviewReducer.productSummaryReducer,
});

export default rootReducer;
